import React, { useEffect } from "react";
import Banner from "../components/allbanner";
import ext from '../images/showroomexterior.jpeg'
import int from '../images/showroominterior.webp'
import team from '../images/team.jpeg'

export default function AboutPage() {
  useEffect(() => {
    const els = document.querySelectorAll("[data-reveal]");
    const onScroll = () => {
      els.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 80) el.classList.add("reveal");
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);


  return (
    <div className="bg-white text-gray-900">
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .reveal { animation: fadeUp 700ms ease both; }
        .card-hover { transition: transform .28s ease, box-shadow .28s ease; }
        .card-hover:hover { transform: translateY(-6px); box-shadow: 0 10px 30px rgba(0,0,0,0.12); }
      `}</style>

      <Banner
        title="Isuzu Gujranwala Motors"
        description="Authorized 3S dealer of Ghandhara Industries Ltd — delivering quality, reliability, and trust since 2013."
      />

      <main className="container mx-auto px-4 py-12">
        {/* Company Story */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-16">
          <div data-reveal>
            <h2 className="text-3xl font-bold mb-4">About Isuzu Gujranwala Motors</h2>
            <p className="text-gray-700 mb-3">
              Established in <strong>2018</strong>, Isuzu Gujranwala Motors is an authorized 3S dealership of
              Ghandhara Industries Limited. We are proud to represent the trusted legacy of ISUZU in Pakistan,
              offering trucks and buses known for performance and durability.
            </p>
            <p className="text-gray-700">
              Our journey started with a vision to serve customers with honesty and excellence.
              Over the years, we’ve built long-term relationships by providing complete solutions under one roof —
              Sales, Service, and Spare Parts — backed by a highly skilled team and modern facilities.
            </p>
          </div>
          <figure className="rounded-lg overflow-hidden shadow-lg" data-reveal>
            <img
              src={ext}
              alt="Isuzu Gujranwala Motors showroom exterior"
              className="w-full h-72 object-cover"
              loading="lazy"
            />
          </figure>
        </section>

        {/* Mission and Vision */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16">
          <div data-reveal>
            <h2 className="text-3xl font-extrabold text-gray-900 mb-4 border-l-4 border-[#D71920] pl-3 inline-block">
              Our Vision
            </h2>
            <p className="text-gray-700 leading-relaxed">
              To be the best and respectable 3S dealership in Pakistan for Commercial Vehicles.
            </p>
          </div>

          <div data-reveal>
            <h2 className="text-3xl font-extrabold text-gray-900 mb-4 border-l-4 border-[#D71920] pl-3 inline-block">
              Our Mission
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Our mission is to delight the Customers and to perform beyond their expectations,
              as customer satisfaction is our top priority.
            </p>
          </div>
        </section>


        {/* Showroom Interior */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-16">
          <figure className="rounded-lg overflow-hidden shadow-lg" data-reveal>
            <img
              src={int}
              alt="Isuzu Gujranwala Motors showroom interior"
              className="w-full h-72 object-cover"
              loading="lazy"
            />

          </figure>
          <div data-reveal>
            <h3 className="text-2xl font-bold mb-3">State-of-the-Art Showroom</h3>
            <p className="text-gray-700 mb-3">
              Our sales display is one of the most advanced in the entire Isuzu network.
              We’ve created a comfortable and modern environment where customers can explore our full range of vehicles.
            </p>
            <p className="text-gray-700">
              With more than <strong>6,000 vehicles sold</strong> and growing, our showroom represents the strength and
              trust our customers place in us every day.
            </p>
          </div>
        </section>

        {/* Highlighted Features */}
        <section className="mb-16" data-reveal>
          <h3 className="text-2xl font-bold mb-6 text-center">Highlighted Features</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              "Established in 2013 as an authorized 3S dealership of Ghandhara Industries Ltd.",
              "State-of-the-art showroom and sales facility.",
              "Over 6,000 vehicles sold since establishment.",
              "24/7 Roadside Assistance through Mobile Workshop Facility.",
              "Annual Service Campaigns to boost customer confidence.",
              "Customer Relations Department with over 1,900 satisfied customers."
            ].map((text, i) => (
              <div key={i} className="bg-gray-50 rounded-lg border p-5 shadow-sm hover:shadow-md transition">
                <p className="text-gray-700">{text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Clients Section */}
        <section className="mb-16" data-reveal>
          <h3 className="text-2xl font-bold mb-4 text-center">Our Valued Clients</h3>
          <p className="text-gray-600 text-center mb-8 max-w-3xl mx-auto">
            We are proud to have served some of Pakistan’s most respected organizations and businesses.
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 text-gray-800">
            {[
              "AK Transport Network", "Al Khair Foam Industries", "Cakes & Bakes", "D.G Khan Cement",
              "Daewoo Pakistan", "DHA", "Diamond Foam", "Gourmet Foods Pakistan",
              "Hico Ice-Cream", "Interwood Mobel", "K&N’s Poultry", "Lucky Cement",
              "Nishat Mills", "Punjab Police", "Servis Industries", "Sufi Goods Transport"
            ].map((client, i) => (
              <div key={i} className="bg-white border rounded-md shadow-sm p-3 text-center hover:bg-red-50 transition">
                {client}
              </div>
            ))}
          </div>
        </section>

        {/* Optional Staff or Facility Image */}
        <section className="mb-16 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div data-reveal>
            <h3 className="text-2xl font-bold mb-3">Dedicated Team & Modern Facility</h3>
            <p className="text-gray-700 mb-3">
              Our success is built on the hard work of <strong>47 skilled employees</strong> — trained professionals
              who ensure every customer receives personalized attention.
            </p>
            <p className="text-gray-700">
              Equipped with the latest tools and technology, our facility ensures top-notch service standards
              across sales, parts, and aftersales support.
            </p>
          </div>
          <figure className="rounded-lg overflow-hidden shadow-lg" data-reveal>
            <img
              src={team}
              alt="Isuzu Gujranwala Motors team"
              className="w-full h-72 object-cover"
              loading="lazy"
            />
          </figure>
        </section>

        {/* CTA Section */}
        <section className="bg-red-50 border-l-4 border-red-500 p-8 rounded-lg flex flex-col sm:flex-row items-start justify-between gap-6" data-reveal>
          <div>
            <h4 className="text-xl font-semibold mb-2">Experience Isuzu Gujranwala Motors</h4>
            <p className="text-gray-700">
              Visit our showroom today and explore our full lineup of commercial vehicles, or get in touch
              with our team for assistance and service appointments.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="/contact"
              className="bg-red-600 text-white px-5 py-2 rounded shadow hover:bg-red-700 transition"
            >
              Contact Us
            </a>
            {/* <a
              href="/showroom"
              className="border border-red-600 text-red-600 px-5 py-2 rounded hover:bg-red-50 transition"
            >
              Visit Showroom
            </a> */}
          </div>
        </section>
      </main>
    </div>
  );
}
